<div *ngIf="visible" class="row">
  <div class="col sm-12">
    <div class="notification is-uberdanger">
      <div class="notification__content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
